<div
  class="font-primary container flex items-center gap-2 text-sm font-semibold"
  [class]="STEM_DIFFICULTY_CATEGORY_TO_CLASS[difficulty]"
>
  <dojo-icon [icon]="STEM_DIFFICULTY_CATEGORY_TO_ICON[difficulty]" [size]="24" />
  <span class="label">{{ STEM_DIFFICULTY_CATEGORY_TO_LABEL_KEY[difficulty] | transloco }}</span>
</div>
